import { useState, useEffect } from 'react'

/* Hook simple para detectar si estamos en tamano movil */
function useEsMovil() {
  const [esMovil, setEsMovil] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= 820 : false
  )
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 820px)')
    const handler = e => setEsMovil(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])
  return esMovil
}

const TEXTOS = {
  en: {
    howItWorks: 'How it works', classes: 'Classes', pricing: 'Pricing', login: 'Log in', startFree: 'Start Free', getStarted: 'Sign Up',
    byEduNova: 'by EduNova Corporation',
    heroSubtitle1: 'Certified English classes.', heroSubtitle2: 'Online and in person.',
    heroDesc: 'Live classes with certified teachers, interactive lessons, games and real conversation practice. Virtual or in-person, built for Colombians who want real results.',
    takeTest: '🎯 Take your free English test', seePlans: 'See plans (COP) →',
    certifiedTeachers: 'Certified teachers · Live + in-person classes',
    levelTest: '🎯 Your English Level Test',
    listening: 'Listening', reading: 'Reading', writing: 'Writing', speaking: 'Speaking',
    overallLevel: 'Your overall level', intermediate: 'Intermediate 🏆',
    learnYourWay: 'Learn the way that suits you best', samePlatform: 'Same platform, two ways to learn.',
    virtualTitle: 'Virtual Live Classes', virtualDesc: 'Small groups, real teachers, real time. Join from anywhere in Colombia.',
    presTitle: 'In-Person Classes', presDesc: 'Face to face lessons for those who prefer being in the room with their teacher.',
    gamesTitle: 'Games & Challenges', gamesDesc: 'Learn through interactive games, daily challenges and XP — practice feels like play.',
    whatLevel: 'What is your English level?', ctaDesc: 'Take our free test and find your exact level in Listening, Reading, Writing and Speaking.',
    startTest: '🚀 Start your free test',
    takeTheTest: 'Take the test', allRights: 'All rights reserved.'
  },
  es: {
    howItWorks: 'Como funciona', classes: 'Clases', pricing: 'Precios', login: 'Iniciar sesion', startFree: 'Empieza gratis', getStarted: 'Regístrate',
    byEduNova: 'por EduNova Corporation',
    heroSubtitle1: 'Clases de ingles certificadas.', heroSubtitle2: 'Virtuales y presenciales.',
    heroDesc: 'Clases en vivo con profesores certificados, lecciones interactivas, juegos y practica de conversacion real. Virtual o presencial, hecho para colombianos que quieren resultados reales.',
    takeTest: '🎯 Toma tu examen de ingles gratis', seePlans: 'Ver planes (COP) →',
    certifiedTeachers: 'Profesores certificados · Clases en vivo + presenciales',
    levelTest: '🎯 Tu examen de nivel de ingles',
    listening: 'Escucha', reading: 'Lectura', writing: 'Escritura', speaking: 'Habla',
    overallLevel: 'Tu nivel general', intermediate: 'Intermedio 🏆',
    learnYourWay: 'Aprende como mejor te funcione', samePlatform: 'Misma plataforma, dos formas de aprender.',
    virtualTitle: 'Clases virtuales en vivo', virtualDesc: 'Grupos pequenos, profesores reales, tiempo real. Conectate desde cualquier parte de Colombia.',
    presTitle: 'Clases presenciales', presDesc: 'Lecciones cara a cara para quienes prefieren estar en el salon con su profesor.',
    gamesTitle: 'Juegos y retos', gamesDesc: 'Aprende con juegos interactivos, retos diarios y XP — practicar se siente como jugar.',
    whatLevel: 'Cual es tu nivel de ingles?', ctaDesc: 'Toma nuestro examen gratis y descubre tu nivel exacto en escucha, lectura, escritura y habla.',
    startTest: '🚀 Comienza tu examen gratis',
    takeTheTest: 'Toma el examen', allRights: 'Todos los derechos reservados.'
  }
}

/* Logo de EduNova, la compania duena de EnglishBridge */
function LogoEduNova({ size = 32 }) {
  return (
    <img src="/edunova-logo.png" alt="EduNova"
      style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }} />
  )
}

/* Logo propio de EnglishBridge (junto al nombre en el navbar) */
function LogoEnglishBridge({ size = 32 }) {
  return (
    <img src="/englishbridge-logo.png" alt="EnglishBridge"
      style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }} />
  )
}

function Wordmark() {
  return (
    <div style={{ display:'flex', alignItems:'baseline', fontWeight:900, fontSize:20, letterSpacing:'-0.5px' }}>
      <span style={{ color:'#F0D878' }}>English</span>
      <span style={{ color:'#fff' }}>Bridge</span>
    </div>
  )
}

function WordmarkGrande() {
  return (
    <div style={{ display:'flex', alignItems:'baseline', fontWeight:900, fontSize:'clamp(32px,6vw,52px)', letterSpacing:'-0.5px' }}>
      <span style={{ color:'#F0D878' }}>English</span>
      <span style={{ color:'#fff' }}>Bridge</span>
    </div>
  )
}

const BANDERAS = [
  { codigo:'co', pais:'Colombia' },
  { codigo:'us', pais:'United States' },
  { codigo:'gb', pais:'United Kingdom' },
  { codigo:'ca', pais:'Canada' },
]

function Bandera({ codigo, pais, size = 20 }) {
  return (
    <img
      src={'https://flagcdn.com/24x18/' + codigo + '.png'}
      alt={pais}
      title={pais}
      style={{ width: size, height: Math.round(size * 0.75), borderRadius: 3, objectFit:'cover', boxShadow:'0 1px 3px rgba(0,0,0,0.4)', flexShrink:0 }}
    />
  )
}

export default function Landing({ onEmpezarExamen, onVerPlanes, onLogin, onCrearCuenta }) {
  const [scrolled,         setScrolled]         = useState(false)
  const [menuMovilAbierto, setMenuMovilAbierto] = useState(false)
  const [idioma,            setIdioma]           = useState('es')
  const esMovil = useEsMovil()
  const t = TEXTOS[idioma]

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  function scrollTo(id) {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior:'smooth' })
    setMenuMovilAbierto(false)
  }

  function irAlInicio() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setMenuMovilAbierto(false)
  }

  const navBtnStyle = {
    background:'none', border:'none', color:'rgba(255,255,255,0.8)', fontFamily:'inherit',
    fontSize:14, cursor:'pointer', padding:'8px 14px', borderRadius:8, textAlign:'left', width:'100%', whiteSpace:'nowrap'
  }

  const SelectorIdioma = ({ compact }) => (
    <div style={{ display:'flex', background:'rgba(255,255,255,0.1)', border:'1px solid rgba(255,255,255,0.2)', borderRadius:8, overflow:'hidden', flexShrink:0 }}>
      <button onClick={() => setIdioma('es')}
        style={{ padding: compact ? '6px 10px' : '7px 12px', border:'none', background: idioma==='es' ? '#D4AF37' : 'transparent',
          color: idioma==='es' ? '#0D1F52' : 'rgba(255,255,255,.7)', fontFamily:'inherit', fontSize:12, fontWeight:800, cursor:'pointer' }}>
        🇪🇸 ES
      </button>
      <button onClick={() => setIdioma('en')}
        style={{ padding: compact ? '6px 10px' : '7px 12px', border:'none', background: idioma==='en' ? '#D4AF37' : 'transparent',
          color: idioma==='en' ? '#0D1F52' : 'rgba(255,255,255,.7)', fontFamily:'inherit', fontSize:12, fontWeight:800, cursor:'pointer' }}>
        🇬🇧 EN
      </button>
    </div>
  )

  return (
    <div style={{ fontFamily:'system-ui, sans-serif', overflowX:'hidden' }}>

      {/* NAVBAR */}
      <nav style={{ position:'fixed', top:0, left:0, right:0, zIndex:100,
        background: (scrolled || menuMovilAbierto) ? 'rgba(13,31,82,0.97)' : 'transparent',
        backdropFilter: (scrolled || menuMovilAbierto) ? 'blur(12px)' : 'none',
        borderBottom: (scrolled || menuMovilAbierto) ? '1px solid rgba(255,255,255,0.1)' : 'none',
        transition:'all .3s ease', padding: esMovil ? '0 16px' : '0 40px' }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', alignItems:'center', height:64, gap:16 }}>
          <button onClick={irAlInicio} style={{ background:'none', border:'none', cursor:'pointer', padding:0, display:'flex', alignItems:'center', gap:10 }}>
            <LogoEnglishBridge size={esMovil ? 28 : 32} />
            <Wordmark />
          </button>
          {!esMovil && (
            <div style={{ display:'flex', alignItems:'center', gap:6, fontSize:11, color:'rgba(255,255,255,0.4)', borderLeft:'1px solid rgba(255,255,255,0.2)', paddingLeft:12 }}>
              <img src="/edunova-logo.png" alt="" style={{ width:14, height:14, objectFit:'contain', opacity:.8 }} />
              {t.byEduNova}
            </div>
          )}
          <div style={{ flex:1 }} />

          {esMovil ? (
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <SelectorIdioma compact />
              <button onClick={() => setMenuMovilAbierto(o => !o)}
                style={{ background:'none', border:'none', color:'#fff', fontSize:26, cursor:'pointer', padding:4 }}>
                {menuMovilAbierto ? '✕' : '☰'}
              </button>
            </div>
          ) : (
            <div style={{ display:'flex', gap:4, alignItems:'center' }}>
              <button onClick={() => scrollTo('como-funciona')} style={navBtnStyle}>{t.howItWorks}</button>
              <button onClick={() => scrollTo('clases')} style={navBtnStyle}>{t.classes}</button>
              <button onClick={onVerPlanes} style={navBtnStyle}>{t.pricing}</button>
              <SelectorIdioma />
              <button onClick={onLogin}
                style={{ background:'none', border:'1px solid rgba(255,255,255,0.3)', color:'#fff', fontFamily:'inherit', fontSize:14, cursor:'pointer', padding:'8px 20px', borderRadius:8, marginLeft:4, whiteSpace:'nowrap' }}>
                {t.login}
              </button>
              <button onClick={onCrearCuenta}
                style={{ background:'linear-gradient(135deg,#D4AF37,#B8912C)', border:'none', color:'#0D1F52', fontFamily:'inherit', fontSize:14, fontWeight:800, cursor:'pointer', padding:'9px 20px', borderRadius:8, whiteSpace:'nowrap' }}>
                {t.getStarted}
              </button>
            </div>
          )}
        </div>

        {esMovil && menuMovilAbierto && (
          <div style={{ background:'rgba(13,31,82,0.98)', padding:'8px 16px 20px', display:'flex', flexDirection:'column', gap:4, borderTop:'1px solid rgba(255,255,255,0.08)' }}>
            <button onClick={() => scrollTo('como-funciona')} style={navBtnStyle}>{t.howItWorks}</button>
            <button onClick={() => scrollTo('clases')} style={navBtnStyle}>{t.classes}</button>
            <button onClick={() => { onVerPlanes(); setMenuMovilAbierto(false) }} style={navBtnStyle}>{t.pricing}</button>
            <button onClick={() => { onLogin(); setMenuMovilAbierto(false) }}
              style={{ background:'none', border:'1px solid rgba(255,255,255,0.3)', color:'#fff', fontFamily:'inherit', fontSize:14, cursor:'pointer', padding:'10px 16px', borderRadius:8, marginTop:6, textAlign:'center' }}>
              {t.login}
            </button>
            <button onClick={() => { onCrearCuenta(); setMenuMovilAbierto(false) }}
              style={{ background:'linear-gradient(135deg,#D4AF37,#B8912C)', border:'none', color:'#0D1F52', fontFamily:'inherit', fontSize:14, fontWeight:800, cursor:'pointer', padding:'11px 16px', borderRadius:8, textAlign:'center' }}>
              {t.getStarted}
            </button>
          </div>
        )}
      </nav>

      {/* HERO */}
      <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#0D1F52,#1B3A8C,#0a1836)', position:'relative', display:'flex', alignItems:'center', overflow:'hidden' }}>
        <svg style={{ position:'absolute', inset:0, width:'100%', height:'100%', opacity:0.08 }} xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse">
              <path d="M50 0H0V50" fill="none" stroke="#F0D878" strokeWidth="0.6" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)"/>
        </svg>

        <div style={{ maxWidth:1320, margin:'0 auto', padding: esMovil ? '110px 20px 60px' : '120px 56px 80px', position:'relative', zIndex:2, width:'100%' }}>
          <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : '1fr 1fr', gap: esMovil ? 40 : 80, alignItems:'center' }}>
            <div style={{ color:'#fff' }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:20 }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, background:'rgba(212,175,55,0.2)', border:'1px solid rgba(212,175,55,0.5)', borderRadius:999, padding:'4px 14px', fontSize:12, fontWeight:600, color:'#F0D878' }}>
                  <img src="/edunova-logo.png" alt="" style={{ width:14, height:14, objectFit:'contain' }} />
                  {t.byEduNova}
                </div>
              </div>
              <WordmarkGrande />
              <h1 style={{ fontSize: esMovil ? 24 : 32, fontWeight:700, lineHeight:1.3, margin:'16px 0 20px', color:'#E5E9F5' }}>
                {t.heroSubtitle1}<br/>{t.heroSubtitle2}
              </h1>
              <p style={{ fontSize: esMovil ? 15 : 18, opacity:.8, lineHeight:1.7, marginBottom:32, maxWidth:480 }}>
                {t.heroDesc}
              </p>
              <div style={{ display:'flex', gap:12, marginBottom:32, flexWrap:'wrap' }}>
                <button onClick={onEmpezarExamen}
                  style={{ background:'linear-gradient(135deg,#D4AF37,#B8912C)', border:'none', color:'#0D1F52', fontFamily:'inherit', fontSize: esMovil ? 14 : 16, fontWeight:800, cursor:'pointer', padding: esMovil ? '13px 22px' : '14px 28px', borderRadius:12, width: esMovil ? '100%' : 'auto', whiteSpace:'nowrap' }}>
                  {t.takeTest}
                </button>
                <button onClick={onVerPlanes}
                  style={{ background:'rgba(255,255,255,0.1)', border:'1.5px solid rgba(255,255,255,0.3)', color:'#fff', fontFamily:'inherit', fontSize: esMovil ? 14 : 16, fontWeight:600, cursor:'pointer', padding: esMovil ? '13px 22px' : '14px 28px', borderRadius:12, width: esMovil ? '100%' : 'auto', whiteSpace:'nowrap' }}>
                  {t.seePlans}
                </button>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                <div style={{ display:'flex', gap:4 }}>
                  {BANDERAS.map((b,i) => <Bandera key={i} codigo={b.codigo} pais={b.pais} />)}
                </div>
                <span style={{ fontSize:13, opacity:.6 }}>{t.certifiedTeachers}</span>
              </div>
            </div>

            <div style={{ background:'rgba(255,255,255,0.05)', backdropFilter:'blur(20px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:20, padding:24, color:'#fff' }}>
              <div style={{ fontSize:13, opacity:.6, marginBottom:16 }}>{t.levelTest}</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:20 }}>
                {[
                  { ic:'🎧', label:t.listening, score:'B1' },
                  { ic:'📖', label:t.reading,   score:'B2' },
                  { ic:'✍️', label:t.writing,   score:'A2' },
                  { ic:'🎤', label:t.speaking,  score:'A1' },
                ].map((s,i) => (
                  <div key={i} style={{ background:'rgba(255,255,255,0.08)', borderRadius:12, padding:'14px 16px' }}>
                    <div style={{ fontSize:20, marginBottom:6 }}>{s.ic}</div>
                    <div style={{ fontSize:12, opacity:.7, marginBottom:4 }}>{s.label}</div>
                    <div style={{ fontSize:24, fontWeight:900, color:'#F0D878' }}>{s.score}</div>
                  </div>
                ))}
              </div>
              <div style={{ background:'linear-gradient(135deg,#D4AF37,#B8912C)', borderRadius:12, padding:16, textAlign:'center' }}>
                <div style={{ fontSize:13, color:'#3D2E06', opacity:.8, marginBottom:4 }}>{t.overallLevel}</div>
                <div style={{ fontSize:36, fontWeight:900, color:'#0D1F52' }}>B1</div>
                <div style={{ fontSize:13, color:'#3D2E06' }}>{t.intermediate}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div id="como-funciona" style={{ background:'#F8FAFF', padding: esMovil ? '48px 20px' : '80px 40px' }}>
        <div style={{ maxWidth:1200, margin:'0 auto' }}>
          <div style={{ textAlign:'center', marginBottom: esMovil ? 36 : 56 }}>
            <h2 style={{ fontSize: esMovil ? 26 : 36, fontWeight:900, color:'#1A1A2E', marginBottom:12 }}>
              {t.learnYourWay}
            </h2>
            <p style={{ fontSize: esMovil ? 15 : 18, color:'#6B7280', maxWidth:560, margin:'0 auto' }}>
              {t.samePlatform}
            </p>
          </div>
          <div style={{ display:'grid', gridTemplateColumns: esMovil ? '1fr' : 'repeat(3,1fr)', gap:24 }}>
            {[
              { ic:'💻', titulo:t.virtualTitle, desc:t.virtualDesc, bg:'#EEF2FF' },
              { ic:'🏫', titulo:t.presTitle,    desc:t.presDesc,    bg:'#FFFBEB' },
              { ic:'🎮', titulo:t.gamesTitle,   desc:t.gamesDesc,   bg:'#F0FDF4' },
            ].map((f,i) => (
              <div key={i} style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:16, padding:28 }}>
                <div style={{ width:52, height:52, borderRadius:14, background:f.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:26, marginBottom:16 }}>
                  {f.ic}
                </div>
                <h3 style={{ fontSize:18, fontWeight:800, color:'#1A1A2E', marginBottom:8 }}>{f.titulo}</h3>
                <p style={{ fontSize:14, color:'#6B7280', lineHeight:1.7 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA EXAMEN */}
      <div id="clases" style={{ background:'linear-gradient(135deg,#0D1F52,#1B3A8C)', padding: esMovil ? '48px 20px' : '80px 40px' }}>
        <div style={{ maxWidth:800, margin:'0 auto', textAlign:'center', color:'#fff' }}>
          <div style={{ fontSize: esMovil ? 40 : 56, marginBottom:16 }}>🎯</div>
          <h2 style={{ fontSize: esMovil ? 26 : 40, fontWeight:900, marginBottom:16 }}>{t.whatLevel}</h2>
          <p style={{ fontSize: esMovil ? 15 : 18, opacity:.8, marginBottom:32, lineHeight:1.6 }}>
            {t.ctaDesc}
          </p>
          <button onClick={onEmpezarExamen}
            style={{ background:'linear-gradient(135deg,#D4AF37,#B8912C)', border:'none', color:'#0D1F52', fontFamily:'inherit', fontSize: esMovil ? 15 : 18, fontWeight:800, cursor:'pointer', padding: esMovil ? '14px 24px' : '16px 36px', borderRadius:14, width: esMovil ? '100%' : 'auto', whiteSpace:'nowrap' }}>
            {t.startTest}
          </button>
        </div>
      </div>

      {/* FOOTER */}
      <div style={{ background:'#0a1836', padding: esMovil ? '28px 20px' : '40px', color:'rgba(255,255,255,0.6)' }}>
        <div style={{ maxWidth:1200, margin:'0 auto', display:'flex', alignItems: esMovil ? 'flex-start' : 'center', justifyContent:'space-between', flexWrap:'wrap', gap:16, flexDirection: esMovil ? 'column' : 'row' }}>
          <div>
            <button onClick={irAlInicio} style={{ background:'none', border:'none', cursor:'pointer', padding:0, display:'flex', alignItems:'center', gap:8, marginBottom:6 }}>
              <LogoEduNova size={20} />
              <Wordmark />
            </button>
            <div style={{ fontSize:12 }}>© 2026 EduNova Corporation. {t.allRights}</div>
          </div>
          <div style={{ display:'flex', gap:20, fontSize:13, flexWrap:'wrap' }}>
            <button onClick={onEmpezarExamen} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>{t.takeTheTest}</button>
            <button onClick={onVerPlanes}     style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>{t.pricing}</button>
            <button onClick={onLogin}         style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontFamily:'inherit' }}>{t.login}</button>
          </div>
        </div>
      </div>
    </div>
  )
}